// ─── src/hooks/useReportLeads.ts ──────────────────────────────────────────────

import { useMutation, useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { deleteReportLead, getReportLeadStats, getReportLeads } from "../api/reportLeads";
import type { ReportLeadParams } from "../types/reportLead";

export const reportLeadKeys = {
  all:   ["reportLeads"] as const,
  list:  (params: ReportLeadParams) => [...reportLeadKeys.all, "list", params] as const,
  stats: () => [...reportLeadKeys.all, "stats"] as const,
};

export const useReportLeads = (params: ReportLeadParams) =>
  useQuery({
    queryKey:        reportLeadKeys.list(params),
    queryFn:         () => getReportLeads(params),
    placeholderData: keepPreviousData,
    staleTime:       30_000,
  });

export const useReportLeadStats = () =>
  useQuery({
    queryKey:  reportLeadKeys.stats(),
    queryFn:   getReportLeadStats,
    staleTime: 60_000,
  });

export const useDeleteReportLead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteReportLead(id),
    onSuccess:  () => qc.invalidateQueries({ queryKey: reportLeadKeys.all }),
  });
};
